var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"my-tag"},[_vm._t("default"),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeable),expression:"closeable"}],staticClass:"fa fa-times-circle",on:{"click":function($event){$event.stopPropagation();return _vm.closeHandler($event)}}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-126358f8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown/myTag.vue
// module id = 168
// module chunks = 0